export default {
  studyPlan: 'Plan de Estudio',
  studyPlanSummary: 'Resumen plan de estudio',
  showHoursBy: 'Mostrar las horas por',
  week: 'Semana',
  weeks: 'Semanas',
  total: 'Total',
  suggestedTotal: 'Total sugerido',
  initialLevel: 'Nivel Inicial',
  finalLevel: 'Nivel Final',
  totalPedagogicalHours: 'Horas pedagógicas totales',
  asteriskLegend: 'El \' * \' representa que ese valor no se contabilizará en el cálculo Total de Horas.',
  number: 'N°',
  requirements: 'Requisitos',
  prerequisites: 'Prerrequisitos',
  totalCredits: 'Total Créditos',
  suggestedMaximum: 'Máximo sugerido',
  totalOfCredits: 'Total de Créditos',
  suggestedMaximumCredits: 'Máximo de Créditos sugerido',
  maximumModulesSuggested: 'Máximo de Módulos sugerido',
  commentsOf: 'Comentarios del',
  enterCommentPlaceholder: 'Ingrese su comentario aquí...',
  level: 'Nivel',
  semester: 'Semestre',
  quarter: 'Trimestre',
  bimonthly: 'Bimestre',
  notApplicable: 'N/A',
  notApply: 'No Aplica',
  inTheArea: 'en el Área',
  totalOfCreditsInTheArea: 'Total de Créditos en el Área',
  without: 'Sin',
  valuesMustBeBetween1To100: 'Los valores deben estar entre 1 ~ 100',
  valuesMustBeBetween1To52: 'Los valores deben estar entre 1 ~ 52',
  twoOrMore: 'Dos o más',
  haveTheSameNumber: 'cuentan con el mismo número',
  selectPrerequisites: 'Seleccione los Prerrequisitos',
  doNotSelect: '-- No seleccionar --',
  toMarkOneOrMore: 'Para marcar una o más',
  removeFromYourSelection: 'quites de su selección (-- No seleccionar --)',
  theseHoursDoNotCountTowardsTotal: 'Estas horas no cuentan para el total',
  automaticCredits: 'Créditos Automáticos',
  plannedCredits: 'Créditos Planificados',
  copyAutomaticCreditInfo: 'Copiar la información del crédito automático',
  changingHoursWillChangeCreditsAutomatically: 'Al cambiar las horas los créditos cambiaran de forma automática',
  thePrerequisitesPlural: 'Los prerrequisitos',
  thePrerequisiteSingular: 'El prerrequisito',
  areLinkedPlural: 'están vinculados',
  isLinkedSingular: 'está vinculado',
  areYouSureYouWantTo: '¿Seguro que quiere',
  unlinkThemPlural: 'desvincularlos',
  unlinkItSingular: 'desvincularlo',
  forThisEgressProfile: 'para este Perfil de Egreso?',
  information: 'Información',
  confirm: 'Confirmar',
  atTransversalSubjectLevel: 'a nivel de Asignatura Transversal',
  changeMade: 'Cambio realizado',
  automatic: 'Automáticos',
  chronologicalHours: 'Horas Cronológicas',
  copyAutomaticHour: 'Copiar Hora Automática',
  copyInformation: 'Copiar la información de la {entity} automático',
  downloadRectorateDecree: 'Decreto de Rectoría (Word)',
  generatingWord: 'Generando Word...'
}
